import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const CloudSlice =  createSlice({
    name:"Cloud",
    initialState:{
        Type:"",
    },
    reducers:{
        SetCloud(state, action: PayloadAction<string>){
            state.Type = action.payload;

        }
    }
});

export const { SetCloud } =CloudSlice.actions
export default CloudSlice.reducer